"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const react_redux_1 = require("react-redux");
const users_1 = require("@/store/ducks/users");
const selectors_1 = require("@/store/ducks/users/selectors");
const deleteUserUseCase_1 = require("@/useCases/users/deleteUserUseCase");
const components_1 = require("@/services/components");
const index_view_1 = __importDefault(require("./index.view"));
function DeleteUserDialogAlert() {
    const dispatch = (0, react_redux_1.useDispatch)();
    const isDeleting = (0, react_redux_1.useSelector)(selectors_1.isDeletingSelector);
    const deletionErrorMessage = (0, react_redux_1.useSelector)(selectors_1.errorMessageSelector);
    const isDialogVisible = (0, react_redux_1.useSelector)(selectors_1.isDeleteUserDialogOpenSelector);
    const userToBeDeleted = (0, react_redux_1.useSelector)(selectors_1.userToBeDeletedSelector);
    const onClose = react_1.default.useCallback(() => {
        components_1.controller.abort();
        dispatch((0, users_1.closeDeleteUserAlert)());
    }, [users_1.closeDeleteUserAlert, components_1.controller]);
    const onProceed = react_1.default.useCallback(() => {
        (0, deleteUserUseCase_1.deleteUserUseCase)(userToBeDeleted?.id)(dispatch);
    }, [userToBeDeleted, dispatch]);
    return (react_1.default.createElement(index_view_1.default, { isOpen: isDialogVisible, onClose: onClose, deletionErrorMessage: deletionErrorMessage, onDismiss: onClose, isDeleting: isDeleting, userToBeDeleted: userToBeDeleted?.username, onProceed: onProceed }));
}
exports.default = react_1.default.memo(DeleteUserDialogAlert);
